import { action } from 'satcheljs/lib/legacy';
export default action('setShowSendDiscardAsIcon')(function setShowSendDiscardAsIcon(viewState, showSendDiscardAsIcon) {
    viewState.showSendDiscardAsIcon = showSendDiscardAsIcon;
});
//# sourceMappingURL=setShowSendDiscardAsIcon.js.map